declare namespace $ {

	type $shm_hitalama_text__text_shm_ba_report_renderer_1 = $mol_type_enforce<
		ReturnType< $shm_ba_report_renderer['empty_text'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	export class $shm_ba_report_renderer extends $mol_view {
		empty_text( ): string
		rows( ): readonly(any)[]
		report( ): $shm_ba_report | null
		dashboard( ): $shm_ba_dashboard | null
		Empty( ): $shm_hitalama_text
		sub( ): ReturnType< $shm_ba_report_renderer['rows'] >
	}
	
}

//# sourceMappingURL=renderer.view.tree.d.ts.map